import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SiteContactComponent } from './pages/contact/contact.component';
import { SiteDepartmentPageComponent } from './pages/department/department.component';
import { SiteDoctorProfileComponent } from './pages/doctor-profile/doctor-profile.component';
import { SiteDoctorsComponent } from './pages/doctors/doctors.component';
import { SiteFaqComponent } from './pages/faq/faq.component';
import { SiteHomeComponent } from './pages/home/home.component';
import { SiteHowItWorksComponent } from './pages/how-it-works/how-it-works.component';
import { SiteSampleReportComponent } from './pages/sample-report/sample-report.component';
import { SiteServicesComponent } from './pages/services/services.component';
import { SiteSpecialtyComponent } from './pages/specialty/specialty.component';
import { AccordionDirective } from './shared/accordion.directive';
import { CtaChooserDirective } from './shared/cta-chooser.directive';
import { SafeHtmlPipe } from './shared/safe-html.pipe';
import { SiteLinkDirective } from './shared/site-link.directive';
import { SiteDoctorRowsComponent } from './shared/doctor-rows.component';
import { SiteSpecialtyCardsComponent } from './shared/specialty-cards.component';
import { WellSpringSiteComponent } from './well-spring-site.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    WellSpringSiteComponent,
    SiteHomeComponent,
    SiteHowItWorksComponent,
    SiteServicesComponent,
    SiteDoctorsComponent,
    SiteFaqComponent,
    SiteContactComponent,
    SiteSpecialtyComponent,
    SiteDoctorProfileComponent,
    SiteSampleReportComponent,
    SiteSpecialtyCardsComponent,
    SiteDoctorRowsComponent,
    SiteDepartmentPageComponent,
    SiteLinkDirective,
    CtaChooserDirective,
    AccordionDirective,
    SafeHtmlPipe
  ],
  exports: [WellSpringSiteComponent]
})
export class WellSpringSiteModule {}
